import { PaymentTerms } from '../../types/enums/PaymentTerms';

export const resolveChosenPriceKeyText = paymentTerm => {
    switch (paymentTerm) {
        case PaymentTerms.YEAR:
            return 'webshopsweden.common.summaryPage.yourPrice.yearlyPrice';
        case PaymentTerms.HALFYEAR:
            return 'webshopsweden.common.summaryPage.yourPrice.halfYearPrice';
        case PaymentTerms.MONTHLY:
            return 'webshopsweden.common.summaryPage.yourPrice.monthPrice';
        case PaymentTerms.QUARTER:
            return 'webshopsweden.common.summaryPage.yourPrice.quarterPrice';
        default:
            return 'webshopsweden.common.summaryPage.yourPrice.monthPrice';
    }
};

export const calculatePrice = (
    isPlusPackageAdded: boolean,
    insurancePrice: any,
    plusPackagePrice: number,
    isTillagsAdded?: boolean,
    tillagsPrice?: number
): number => {
    if (isPlusPackageAdded) {
        return insurancePrice + plusPackagePrice;
    } else if (isTillagsAdded) {
        return insurancePrice + tillagsPrice;
    }
    return insurancePrice;
};
